export const RESET_PAGINATION = 'RESET_PAGINATION';

export const resetPagination = () => ({
  type: RESET_PAGINATION,
});
